// IdleWrapper.js
import React, { useContext, useState, useEffect } from 'react';
import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
import CustomModal from '../components/Modal/CustomModal';
import AuthContext from '../store/AuthContext';

const IdleWrapper = ({ children }) => {
  const { logout, isLoggedIn } = useContext(AuthContext);
  const [isIdle, setIsIdle] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleOnIdle = () => {
    setIsIdle(true);
  };

  const handleOnActive = () => {
    if (isIdle) {
      setShowModal(true);
      setTimeout(() => {
        logout();
        setShowModal(false);
      }, 5000);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    console.log("isLoggedIn:", isLoggedIn);
  }, [isLoggedIn]);

  return (
    <>
      {isLoggedIn ? (
        <IdleTimerProvider
          timeout={45 * 60 * 1000} // 30 minutes
          onIdle={handleOnIdle}
          onActive={handleOnActive}
          debounce={500}
        >
          {children}
          <CustomModal isOpen={showModal} onClose={closeModal}>
            <h2>Session Timeout</h2>
            <p>You have been inactive for more than 45 minutes. For your security, you will be logged out shortly.</p>
          </CustomModal>
        </IdleTimerProvider>
      ) : (
        children
      )}
    </>
  );
};

export default IdleWrapper;
